export default "__VITE_ASSET__CBYfAPFR__"